import { cn } from '@/lib/utils'
import { Divider } from '@mui/material'
import React from 'react'

export default function Stats({className}) {
  return (
    <div>
        <section className={cn("shadow-lg bg-white w-11/12 md:w-10/12 mx-auto rounded-xl my-10", className)}>
<div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-10 mx-auto">
  <div className="md:grid flex flex-wrap gap-6 grid-cols-2 sm:gap-12 lg:grid-cols-5 lg:gap-8">
    <div className=''>
      <h4 className="text-lg sm:text-xl font-medium text-gray-600">Immobilien</h4>
      <p className="mt-2 sm:mt-3 text-4xl sm:text-6xl font-medium text-prime-800">+350</p>
      <p className="mt-1 text-gray-500">erfolgreich vermittelt</p>
    </div>
    <div className='flex  items-center justify-center'>
    <Divider className='hidden md:block' orientation="vertical" flexItem />

    </div>
    <div>
      <h4 className="text-lg sm:text-xl font-medium text-gray-600">Besichtigungstermine</h4>
      <p className="mt-2 sm:mt-3 text-4xl sm:text-6xl font-medium text-prime-800">+5.000</p>
      <p className="mt-1 text-gray-500">organisiert</p>
    </div>
    <div className='flex  items-center justify-center'>
    <Divider className='hidden md:block' orientation="vertical" flexItem />

    </div>
    <div>
      <h4 className="text-lg sm:text-xl font-medium text-gray-600">Erfahrung</h4>
      <p className="mt-2 sm:mt-3 text-4xl sm:text-6xl font-medium text-prime-800">+45</p>
      <p className="mt-1 text-gray-500">Jahre Vertrauen aufgebaut</p>
    </div>
  </div>
</div>
    </section>
    </div>
  )
}
